













import Vue from 'vue';
import Component from 'vue-class-component';
import TopToolbar from './components/TopToolbar.vue';

@Component({
  components: {
    TopToolbar
  }
})
export default class extends Vue {
}

